import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import { useQuery, useQueryClient } from '@tanstack/react-query';
import API_URL from './api/config';

function SignupNoClan() {
    const navigate = useNavigate();
   
   
    const [clanName, setClanName] = useState('');

    const handleClanSubmit = async () => {
    if (!clanName.trim()) {
      toast.error("Please enter your clan name.");
      return;
    }

    try {
      const res = await axios.post(
        `${API_URL}/reg-signup-noclan-api`,
        { clan_name: clanName },
        { withCredentials: true }
      );

      if (res.data.Status === "Success") {
        navigate(res.data.redirect);
      } else {
        toast.error("Failed to register clan.");
      }
    } catch (error) {
      console.error("Clan submission error:", error);
      toast.error("Something went wrong.");
    }
  };


    return (

      <div class="d-flex align-items-center justify-content-center">
   

      <div class="row" style={{marginTop: '5%'}}>
      
          <div class="col-md-1">
              
          </div>
      
          <div class="col-md-10">
      
          <div class="card border-0 shadow col-md-6 bg-secondary text-white">
              <div class="card-body">
                  <p class="h4 text-center">You can register your clan here.</p>
                  <p class="text-center"></p>
                
                      
                  <div class="row g-3 align-items-end">
      
                      <div class="col-6 vstack gap-3">
                          <div class="">
                              <label for="account" class="form-label">Enter Your Clan</label>
                            
      
                              <input
                                type="text"
                                name="clan_name"
                                className="form-control"
                                required
                                value={clanName}
                                onChange={(e) => setClanName(e.target.value)}
                            />
                          </div>
                          
                      </div>
      
                      <div class="col-12 mb-3">
                      <div class="d-flex justify-content-between">

                          <Link onClick={() => navigate(-1)} class="btn btn-back">Back</Link> 
                          
                          <button onClick={handleClanSubmit} class="btn btn-primary" type="submit">Continue</button>

                      </div>
                  </div>
      
                  </div>
      
                  
              </div>
          </div>
      </div>
      
      <div class="col-md-1">
              
          </div>
      
      
      </div>
      
      
      </div>


    );
}

export default SignupNoClan;
